export const FUNDRAISER_PROFILE_SYNC_KEY = "FUNDRAISER_PROFILE_SYNC";

export const normalizeFundraiserProfileLogo = (logo) =>
  typeof logo === "string" ? logo : "";

export const parseFundraiserProfileSync = (rawValue) => {
  if (!rawValue) return null;

  try {
    const parsed = JSON.parse(rawValue);
    if (
      !parsed ||
      !Object.prototype.hasOwnProperty.call(parsed, "logo")
    ) {
      return null;
    }

    return {
      logo: normalizeFundraiserProfileLogo(parsed.logo),
      timestamp: parsed.timestamp || Date.now(),
    };
  } catch (_) {
    return null;
  }
};

export const broadcastFundraiserProfileLogoSync = (logo) => {
  const normalizedLogo = normalizeFundraiserProfileLogo(logo);

  try {
    localStorage.setItem(
      FUNDRAISER_PROFILE_SYNC_KEY,
      JSON.stringify({
        logo: normalizedLogo,
        timestamp: Date.now(),
      }),
    );
  } catch (_) {}

  window.dispatchEvent(
    new CustomEvent("profile-updated", {
      detail: { logo: normalizedLogo },
    }),
  );
};
